/**
 * mixPannel track events Section
 */
export const mxpTrackSection = {
	// Profile
	APNA_CARD: "Apna Card",
	POWER_STARTER: "Power Starter Banner",
	GROUP_CARD: "Group Card",
	ENHANCE_PROFILE: "Enhance your Profile Banner",
	CONNECTION_CARD: "Connection Card",
	STATS_BANNER: "Stats Banner",

	// Jobs
	TESTIMONIAL_CARDS: "Testimonial cards",
	JOB_CARD: "Job Card",
	APPLY_NOW: "Apply Now button",
	JOB_FEED: "Job Feed",
	HERO_SECTION: "Hero Section",
	JOB_TYPE_SEL_MODAL: "Job Type Selection Modal",
	JOB_NOTIFICATION_BANNER: "Job Notification banner",
	PAGINATION: "Pagination",
};

/**
 * mixPannel track events CTA
 */
export const mxpTrackCTA = {
	CONNECT: "Connect",
	SHARE: "Share",
	EDIT: "Edit",
	PROCEED: "Proceed",
	PROFILE_CARD: "Profile Card",
	POWER_STARTER: "You are a power starter",
	SEE_ALL: "See All",
	ENHANCE_PROFILE: "Enhance your profile",
	CLAPS: "Claps",
	REFERALS: "Referrals",
	FRIENDS: "Friends",
	VIEWS: "Views",
	APPLY_NOW: "Apply Now",
	CONTINUE_ON_APNA: "Continue on apna app",
	APPLY: "Apply",
};

/**
 * mixPannel track events TriggerEvent
 */
export const mxpTrackTriggerEvent = {
	// profile
	WEB_EDIT_BTN: "Web_Edit Button Click",
	WEB_CONNECT_BTN: "Web_Connect Button Click",
	WEB_PROFILE_CARD: "Web_Profile Card Click",
	WEB_COMMUNITY_GROUP: "Web_Community Group Click",
	WEB_COMMUNITY_SEE_ALL: "Web_Community See All Click",
	WEB_ENHANCE_PROFILE: "Web_Enhance your Profile Banner Click",
	WEB_CONNECTION: "Web_Connection Click",
	WEB_CONNECTION_SEE_ALL: "Web_Connection See All Click",
	WEB_STATS_VIEWS: "Web_Stats Views Click",
	WEB_STATS_FRIENDS: "Web_Stats Friends Click",
	WEB_STATS_REFERRALS: "Web_Stats Referrals Click",
	WEB_STATS_CLAPS: "Web_Stats Claps Click",

	// Jobs
	APPLY_NOW_BTN_CLK: "Apply Now Button Click",
	APPLY_NOW_BTN: "Apply Now button",
	JOB_FEED_LOADNG_FAILURE: "Job feed loading failure",
};
